import React, { ForwardedRef, useContext } from 'react';
import { OriginIconProps } from '../type';
import { Context } from '../context';

function IconLeftComponent(props: OriginIconProps, ref: ForwardedRef<SVGSVGElement>) {
    const { prefix: prefixFromContext } = useContext(Context);
    const { className = '', prefix: prefixFromProps, width = '1em', height = '1em', useCurrentColor = true, spin, ...rest } = props;

    const prefix = prefixFromProps || prefixFromContext || 'alliance';
    const loadingKls = spin ? ` ${prefix}-icon-loading` : '';
    return <svg className={`${prefix}-icon ${prefix}-icon-left${loadingKls} ${className}`} width={width} height={height} viewBox="0 0 16 16" fill={useCurrentColor ? 'currentColor' : '#000'} xmlns="http://www.w3.org/2000/svg" {...rest} ref={ref}><path fillRule="evenodd" clipRule="evenodd" d="M10.5612 3.77937C10.6913 3.90954 10.6913 4.1206 10.5612 4.25077L6.81189 8.00003L10.5612 11.7493C10.6913 11.8795 10.6913 12.0905 10.5612 12.2207L10.0898 12.6921C9.95959 12.8223 9.74854 12.8223 9.61836 12.6921L5.39767 8.47144C5.13732 8.21109 5.13732 7.78898 5.39767 7.52863L9.61836 3.30797C9.74854 3.17779 9.95959 3.17779 10.0898 3.30797L10.5612 3.77937Z" fillOpacity="1"/></svg>;
}

const IconLeft = React.forwardRef(IconLeftComponent);
export default IconLeft;
